<template>
  <section class="content" style="padding-left: 0px;padding-right: 0px;">
    <div class="row" v-if="!contentLoaderOn">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <p class="home-txt" style="font-family:LightRubber,Helvetica,Arial,sans-serif;">
          Welcome to the Rubbermaid Commercial Smart App. Please select one of the following to view content
          that suits you.
        </p>
        <div class="row" style="margin-top: 30px;">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="row">
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="text-align: center;">
                <div class="home-box1">
                   <router-link to="/videos">
                  <div style="height: 150px;">
                    <img class="hbox-img" src="static/img/home-page/Videos.png" alt="People">
                  </div>
                  <div class="hbox-txt">
                    <p class="htxt">VIDEOS</p>
                  </div>
                   </router-link>
                </div>
              </div>
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="text-align: center;">
                <div class="home-box2">
                  <router-link to="/documents">
                  <div style="height: 150px;">
                    <img class="hbox-img" src="static/img/home-page/Product_Use_Manuals.png" alt="People">
                  </div>
                  <div class="hbox-txt">
                    <p class="htxt">MANUALS</p>
                  </div>
                   </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="contentLoaderOn">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <vue-content-loading :width="300" :height="100">
          <rect x="25%" y="5" rx="2" ry="2" width="50%" height="3"/>
          <rect x="30%" y="15" rx="2" ry="2" width="35%" height="3"/>

          <rect x="20%" y="25" rx="4" ry="4" width="23%" height="60"/>

          <rect x="55%" y="25" rx="4" ry="4" width="23%" height="60"/>

        </vue-content-loading>
      </div>
    </div>
  </section>
</template>

<script>
  import VueContentLoading from 'vue-content-loading'
  export default {
    components: {
      VueContentLoading
    },
    data() {
      return {
        contentLoaderOn: true
      }
    },
    created() {
      setTimeout(() => (this.runLoader()), 2000)
    },
    methods: {
      runLoader() {
        this.contentLoaderOn = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// homeView.vue?1ea4a0f5